import { __awaiter, __generator, __spreadArrays } from "tslib";
import number, { shortNumber } from '../../utils/number';
import { InterpolatedColor } from 'interpolated-colors';
import colorContrast from 'color-contrast';
import { loadGeo } from './loadGeo.js';
import get from 'lodash.get';
import { DEF_HEAT_COLOR, bindAutoHideLabel } from '../utils';
import './icon-country.scss';
var LABEL_COLOR = '#061632';
var LABEL_COLOR_LIGHT = '#FFF';
var mapName = 'WorldMap2021';
var World2021 = /** @class */ (function () {
    function World2021(echarts) {
        this.datasetMap = new Map();
        this.installed = false;
        this.echarts = echarts;
        this.config = World2021.DEF_COLOR_OPT;
        this.installed = !!echarts.getMap(mapName);
        this._dataset = {};
    }
    Object.defineProperty(World2021, "DEF_COLOR_OPT", {
        get: function () {
            return {
                roam: false,
                fontSize: 14,
                labelVisible: true,
                labelUnit: '',
                labelColor: LABEL_COLOR,
                labelColorLight: LABEL_COLOR_LIGHT,
                autoHideLabel: false,
                visualMapVisible: false,
                colors: DEF_HEAT_COLOR,
                defaultFill: '#F4F5F8',
                borderColor: '#e5e5e5',
                selectedFill: '#4ABD40',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(World2021.prototype, "dataset", {
        get: function () {
            // eslint-disable-next-line no-underscore-dangle
            return this._dataset;
        },
        set: function (dataset) {
            var vm = this;
            if (!(dataset && Array.isArray(dataset.source))) {
                throw new TypeError("dataset should be:\n{\n  dimensions: ['name', 'value', ...],\n  source: Array<{name: '\u9ED1\u9F99\u6C5F', value: 12, ...}>\n}\n      ");
            }
            vm.datasetMap.clear();
            dataset.source.forEach(function (authInfo) {
                var value = authInfo[vm.valueKey] || 0;
                var name = authInfo[vm.nameKey];
                vm.datasetMap.set(name, value);
            });
            // eslint-disable-next-line no-underscore-dangle
            vm._dataset = dataset;
        },
        enumerable: false,
        configurable: true
    });
    World2021.prototype.loadingCallback = function (bol) {
    };
    World2021.install = function (echarts) {
        return __awaiter(this, void 0, void 0, function () {
            var isInstalled, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isInstalled = echarts.getMap(mapName);
                        if (!!isInstalled) return [3 /*break*/, 2];
                        return [4 /*yield*/, loadGeo()];
                    case 1:
                        data = _a.sent();
                        echarts.registerMap(mapName, data);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    World2021.prototype.install = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.installed) {
                            return [2 /*return*/];
                        }
                        this.loadingCallback(true);
                        return [4 /*yield*/, World2021.install(this.echarts).finally(function () { return _this.loadingCallback(false); })];
                    case 1:
                        _a.sent();
                        this.installed = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(World2021.prototype, "nameKey", {
        get: function () {
            return get(this, 'dataset.dimensions[0]', 'name');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(World2021.prototype, "valueKey", {
        get: function () {
            return get(this, 'dataset.dimensions[1]', 'value');
        },
        enumerable: false,
        configurable: true
    });
    // eslint-disable-next-line no-unused-vars,class-methods-use-this
    World2021.prototype.onClick = function (data, name, series) {
    };
    // eslint-disable-next-line class-methods-use-this
    World2021.prototype.formatNumber = function (num) {
        return number(num);
    };
    World2021.prototype.getFullName = function (name) {
        return name;
    };
    World2021.prototype.tooltipFormatter = function (data) {
        var vm = this;
        var name = data[vm.nameKey];
        var value = data[vm.valueKey];
        // if (['WO', 'EP'].includes(name)) {
        //   return ''
        // }
        if ('authorityCountLabel' in data) {
            return "<div style=\"color: " + vm.config.labelColor + "; text-align: left;\">\n                <span style=\"margin-right: 5px\" class=\"icon-country-db icon-" + name + "\"></span>" + (data.authorityName || vm.getFullName(name)) + "\n                    </br>\n                <span style=\"margin-left: 28px\">" + (vm.config.labelUnit || '') + " " + data.authorityCountLabel + "<span>\n                </div>";
        }
        return "<span class=\"icon-country-db icon-" + name + "\"></span>\n            <span style=\"color:" + vm.config.labelColor + ";\">" + vm.getFullName(name) + ": " + (vm.config.labelUnit || '') + " " + vm.formatNumber(value) + "<span>";
    };
    World2021.prototype.getVisualMap = function () {
        var vm = this;
        var min = Number.MAX_SAFE_INTEGER || 9007199254740991;
        var max = Number.MIN_SAFE_INTEGER || -9007199254740991;
        // @ts-ignore
        vm.dataset.source.forEach(function (authInfo) {
            var value = authInfo[vm.valueKey] || 0;
            var name = authInfo[vm.nameKey];
            vm.datasetMap.set(name, value);
            if (value < min) {
                min = value;
            }
            if (value > max) {
                max = value;
            }
        });
        if (min >= max) {
            min = 0;
        }
        var colors = vm.config.colors.length === 1 ? __spreadArrays(vm.config.colors, [vm.config.defaultFill]) : vm.config.colors;
        return {
            max: max,
            min: min,
            zlevel: 2,
            right: 25,
            text: ['Max', min === 0 ? '0' : 'Min'],
            hoverLink: false,
            seriesIndex: 0,
            show: vm.config.visualMapVisible,
            type: vm.config.colors.length <= 2 ? 'continuous' : 'piecewise',
            splitNumber: colors.length,
            color: max === 0 ? [colors[0], vm.config.defaultFill] : colors,
        };
    };
    World2021.prototype.geoLabelFormatter = function (d) {
        var vm = this;
        var name = d.name;
        var value = vm.datasetMap.get(name);
        if (!value) {
            return '';
        }
        if (name === 'WO' || name === 'EP') {
            return [
                "{title|" + (name === 'WO' ? 'WIPO' : 'EPO') + "}",
                "{title|" + shortNumber(value) + "}",
            ].join('\n');
        }
        else {
            return name + ": " + shortNumber(value);
        }
    };
    World2021.prototype.echartBeforeOptHook = function (opt) {
        return opt;
    };
    World2021.prototype.getEchartOptions = function (dataset) {
        if (dataset === void 0) { dataset = this.dataset; }
        var vm = this;
        if (vm.dataset !== dataset) {
            vm.dataset = dataset;
        }
        var chartOptions = vm.config;
        var source = vm.dataset.source;
        if (!Array.isArray(source)) {
            return {};
        }
        var visualMap = vm.getVisualMap();
        // @ts-ignore
        var rangeStep = (visualMap.max - visualMap.min) / (visualMap.splitNumber - 1);
        // @ts-ignore
        var gradient = InterpolatedColor(visualMap.color.map(function (color, index) {
            // @ts-ignore
            return [visualMap.max - rangeStep * index, color];
        }));
        var defEmphasis = {
            label: {
                // BUG:show不起作用 https://github.com/apache/echarts/issues/12764
                show: false,
                formatter: function () {
                    return '';
                },
                color: 'rgba(255,255,255,0)',
                backgroundColor: 'rgba(255,255,255,0)',
                borderWidth: 0,
                borderColor: 'none',
            },
            itemStyle: {
                areaColor: chartOptions.selectedFill,
            },
        };
        var option = {
            tooltip: {
                trigger: 'item',
                showDelay: 0,
                transitionDuration: 0.2,
                backgroundColor: '#fff',
                borderColor: '#c5c4c4',
                extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);',
                formatter: function (params) {
                    // @ts-ignore
                    if (!params.data) {
                        return '';
                    }
                    // @ts-ignore
                    return vm.tooltipFormatter(params.data);
                },
            },
            visualMap: [visualMap],
            geo: {
                roam: chartOptions.roam,
                zoom: 1.2,
                zlevel: 1,
                scaleLimit: {
                    min: 1,
                    max: 5,
                },
                type: 'map',
                map: mapName,
                label: {
                    show: chartOptions.labelVisible,
                    formatter: function (d) {
                        return vm.geoLabelFormatter(d);
                    },
                    backgroundColor: '#fff',
                    padding: 4,
                    borderRadius: 3,
                    borderWidth: 1,
                    borderColor: '#ebecf0',
                    color: LABEL_COLOR,
                    fontSize: chartOptions.fontSize,
                    rich: { /* 不能删 */},
                },
                emphasis: defEmphasis,
                itemStyle: {
                    areaColor: chartOptions.defaultFill,
                    borderColor: chartOptions.borderColor,
                },
                regions: ['WO', 'EP'].map(function (name) {
                    var value = vm.datasetMap.get(name) || 0;
                    function formatter(d) {
                        return vm.geoLabelFormatter(d);
                    }
                    return {
                        name: name,
                        itemStyle: {
                            opacity: value ? 1 : 0,
                        },
                        label: {
                            show: !!value,
                            formatter: formatter,
                            backgroundColor: 'transparent',
                            borderColor: 'transparent',
                            borderWidth: 0,
                            rich: {
                                title: {
                                    color: (function () {
                                        try {
                                            var bgColor = gradient(value);
                                            var contrastScore = colorContrast(chartOptions.labelColor, bgColor);
                                            return contrastScore >= 7 ? chartOptions.labelColor : chartOptions.labelColorLight;
                                        }
                                        catch (err) {
                                            return LABEL_COLOR;
                                        }
                                    })(),
                                    fontSize: chartOptions.fontSize,
                                    lineHeight: chartOptions.fontSize * 1.2,
                                    textAlign: 'center',
                                },
                            },
                        },
                        emphasis: {
                            label: {
                                // BUG:show不起作用 https://github.com/apache/echarts/issues/12764
                                show: true,
                                color: chartOptions.labelColorLight,
                                formatter: formatter,
                                rich: {
                                    title: {
                                        color: chartOptions.labelColorLight,
                                    },
                                },
                            },
                            itemStyle: {
                                areaColor: chartOptions.selectedFill,
                            },
                        },
                    };
                }),
            },
            series: [
                {
                    type: 'map',
                    map: mapName,
                    geoIndex: 0,
                },
            ],
            dataset: vm.dataset,
        };
        return this.echartBeforeOptHook(option);
    };
    World2021.prototype.plot = function (mountPoint, dataset) {
        return __awaiter(this, void 0, void 0, function () {
            var vm, chart, opt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vm = this;
                        if (!!this.installed) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.install()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        chart = this.echarts.init(mountPoint);
                        opt = this.getEchartOptions(dataset);
                        chart.setOption(opt);
                        chart.on('click', 'series', function (series) {
                            if (series.data) {
                                vm.onClick(series.data, series.data[vm.nameKey], series);
                            }
                        });
                        if (vm.config.autoHideLabel && get(opt, 'geo.label.show')) {
                            World2021.bindAutoHideLabel(chart);
                        }
                        return [2 /*return*/, chart];
                }
            });
        });
    };
    World2021.bindAutoHideLabel = bindAutoHideLabel;
    return World2021;
}());
export default World2021;
//# sourceMappingURL=index.js.map